<template>
  <div class="container">
    <span class="title">{{ titleOne }}</span>
    <TableOne
      :funcionarioAscendidos="funcionarioAscendidos"
      :readOnly="readOnly"
    />

    <span class="title">{{ titleTwo }}</span>
    <TableTwo
      :funcionariosRecontratados="funcionariosRecontratados"
      :readOnly="readOnly"
    />
  </div>
</template>

<script>
import TableOne from "./components/mainTableTrhee/TableOne.vue";
import TableTwo from "./components/mainTableTrhee/TableTwo.vue";

export default {
  props: ["funcionarioAscendidos", "funcionariosRecontratados", "readOnly"],
  components: {
    TableOne,
    TableTwo,
  },
  data() {
    return {
      //Primera Tabla
      titleOne:
        "3.1 Porcentaje de funcionarios de planta ascendidos o promovidos, respecto de la Planta Efectiva de Personal",

      //Segunda Tabla
      titleTwo:
        "3.2 Porcentaje de funcionarios recontratados en grado superior, respecto del total de funcionarios contratados",
    };
  },
};
</script>

<style scoped>
.title {
  color: #052333;
  font-size: 17px;
  font-weight: bold;
  margin-top: 10px !important;
  margin-bottom: 10px;
}
</style>
